<template>
  <div class="example-wrap">
    <div class="title">
      <img class="border" src="@/assets/images/mobile/border.png">
      <div class="name">往期案例</div>
    </div>
    <div class="container">
      <ul class="list">
        <li class="one-item">
          <img src="@/assets/images/mobile/z1.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z2.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z3.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z4.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z5.png" alt="">
        </li>

        <li class="one-item">
          <img src="@/assets/images/mobile/z1.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z2.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z3.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z4.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z5.png" alt="">
        </li>

        <li class="one-item">
          <img src="@/assets/images/mobile/z1.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z2.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z3.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z4.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z5.png" alt="">
        </li>

        <li class="one-item">
          <img src="@/assets/images/mobile/z1.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z2.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z3.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z4.png" alt="">
        </li>
        <li class="one-item">
          <img src="@/assets/images/mobile/z5.png" alt="">
        </li>
      </ul>
    </div>
    <div class="desc-box">
      <Title title1="先进设备， 一流实力" title2="ADVANCED EQUIPMENT, FIRST CLASS CAPACITY"/>
      <div class="desc">
        敏伟拥有强大的机械设备制造能力，引进国内一流的矿山机械加工设备。我们坚持不断地创新，持续改进产品，不断提高产品的可靠性，我们立志成为破碎筛分行业的世界品牌。
      </div>
    </div>
    <div class="btn" @click="goMore">查看更多</div>
  </div>
</template>

<script>
import Title from '@/views/mobile/components/Title'
export default {
  name: "Example",
  components: { Title },
  data() {
    return {
      images: [
        require('@/assets/images/mobile/z1.png'),
        require('@/assets/images/mobile/z2.png'),
        require('@/assets/images/mobile/z3.png'),
        require('@/assets/images/mobile/z4.png'),
        require('@/assets/images/mobile/z5.png')
      ]
    }
  },
  methods: {
    goMore () {
      this.$router.push({path: '/mb_product'})
    }
  }
}
</script>

<style lang="less" scoped>
.example-wrap {
  margin-top: 0.5rem;
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    display: flex;
    justify-content: center;
    width:100%;
    height: 2rem;
    position: relative;
    .border {
      width: 60%;
    }
    .name {
      position: absolute;
      top: 25%;
      left: auto;
      right: auto;
      font-size: 0.8rem;
      font-weight: 600;
      color: #3a8ee6;
    }
  }
  .desc-box {
    padding: 0.4rem;
    .desc {
      text-indent: 2em;
      margin-top: 0.32rem;
      font-size: 0.5rem;
      color: #999999;
    }
  }
  .btn {
    font-size: 0.4rem;
    border: 1px solid #3a8ee6;
    padding: 0.2rem 0.5rem;
    color: #3a8ee6;
    border-radius: 0.1rem;
    margin-bottom: 0.5rem;
  }



  @item-space: 0.15rem;
  @item-width: 5rem;
  @item-num: 5;
  @start-position: -5.2rem;
  @end-position: -5.2rem - @item-num*@item-width - @item-num*@item-space;

  .container {
    width: calc(100% - 0.6rem);
    height: 4rem;
    border-radius: 6px;
    overflow: hidden;
    margin: 0.5rem 0.3rem;
  }

  .list {
    list-style-type: none;
    margin: 0;
    padding-left: 0;
    animation: 30s move infinite linear;
    white-space: nowrap;
    font-size: 0;

    .one-item {
      width: @item-width;
      height: 4rem;
      display: inline-block;
      overflow: hidden;
      padding-right: @item-space;
    }
  }

  img {
    width: 100%;
    height: 100%;
  }

  // 通过计算出来的偏移值才能做到无缝
  @keyframes move {
    0% {
      transform: translateX(@start-position);
    }
    100% {
      transform: translateX(@end-position);
    }
  }
}
</style>
